import React, { useState, useEffect, Fragment } from "react";
import { Container, Spinner, Row, Col} from "react-bootstrap";
import { useUser } from "../context/UserContext";
import { useProblem } from "../context/ProblemContext";
import ProblemType from "../components/ProblemType"
//import ProblemService from "../services/problem.service";

const Home = () => { 
  const { isLoggedIn, userData } = useUser();
  //const [problems, setProblems] = useState([]);
  const {problems} = useProblem();
  
  var msg = "";
  if(isLoggedIn && userData) 
    msg= userData.username;
  else
    msg = "!";

    if (!problems) {
      return (
        <Container>
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </Container>
      );
    }

    return( 
      <Fragment>
        <div className="bg-light mx-0 my-0 p-5 rounded-lg">
          <h1>Welcome {msg}</h1>
        </div> 


        <Container className = "mt-5 mb-5">
          <Row className="m-3">
            <h2>Integrated Project Based Learning</h2>
          </Row>
          <Row className="m-3">
           {
              //Todo: make sure problems is not null before doing this step
                      problems.map((item) => ( 
                          item.categoryid == 8
                            ? <ProblemType pbtype={item} />
                            : null                
                         
                      )) 
            } 
          </Row>
        </Container>

        <hr />

        <Container className = "mt-5 mb-5">
          <Row className="m-3">
            <h2>Brainteasers</h2>
          </Row>
          <Row className="m-3">
           {
                    /*  problems.map((item) => ( 
                          // Presently we only fetch 
                          // title from the API 
                          //<h4>{item.problemtypename}</h4> 
                          item.categoryid != 8 
                            ? <ProblemType pbtype={item} />
                            : null                
                         
                      )) */
                      problems.map((item) => ( 
                       
                          item.categoryid != 8 
                          ? <ProblemType pbtype={item} />
                          : null  
                       
                    ))

            } 
          </Row>
        </Container>

      </Fragment>
 
        
    );
};
  
  export default Home;